require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./context"), require("./link"), require("./paragraph"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./context", "./link", "./paragraph"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./context"), require("./link"), require("./paragraph")) : factory(root["./utils"], root["./context"], root["./link"], root["./paragraph"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__24__, __WEBPACK_EXTERNAL_MODULE__29__, __WEBPACK_EXTERNAL_MODULE__62__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[25],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__24__;

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(267);


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.FlyoutPosition = void 0;

var _Flyout = _interopRequireDefault(__webpack_require__(98));

exports["default"] = _Flyout["default"];
exports.Flyout = _Flyout["default"];

var _ContextFlyout = _interopRequireDefault(__webpack_require__(271));

exports.ContextFlyout = _ContextFlyout["default"];

var FlyoutPosition = _interopRequireWildcard(__webpack_require__(63));

exports.FlyoutPosition = FlyoutPosition;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "ba-common-flyout{display:inline-block}.ba-common-flyout{position:relative;display:inline-block}.ba-common-flyout__label{display:inline-block}.ba-common-flyout__label:hover{cursor:pointer}.ba-common-flyout__container{background-clip:padding-box;border-top-color:rgba(0,0,0,0.1);line-height:1.42857143;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;line-break:auto;border:1px solid rgba(0,0,0,0.1);position:absolute;opacity:1;margin:auto;background-color:#fff;height:auto;opacity:1;z-index:9001;box-shadow:0 2px 8px 0 rgba(0,0,0,0.1)}.ba-common-flyout__container .ba-common-flyout-arrow{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;border-width:11px;z-index:-1}@media screen and (-ms-high-contrast: active){.ba-common-flyout__container .ba-common-flyout-arrow{border-color:#000}}.ba-common-flyout__container .ba-common-flyout-arrow::before{box-sizing:border-box;position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;border-width:10px;bottom:-10px;left:1px;content:\" \"}@media screen and (-ms-high-contrast: active){.ba-common-flyout__container .ba-common-flyout-arrow::before{border-color:#000}}.ba-common-flyout__container:focus{outline:none}.ba-common-flyout__container.is-hidden{visibility:hidden}.ba-common-flyout__container.padding-none{padding:0}.ba-common-flyout__container.padding-default{padding:16px;width:300px;text-align:center}[dir=\"ltr\"].ba-common-flyout__container__title{text-align:left}[dir=\"rtl\"].ba-common-flyout__container__title{text-align:right}[dir=\"ltr\"] .ba-common-flyout__container__title,.ba-common-flyout__container__title{text-align:left}[dir=\"rtl\"] .ba-common-flyout__container__title{text-align:right}.ba-common-flyout__container__title .ba-common-paragraph{display:inline-block;margin:0;width:240px;color:#161616;font-size:14px}.ba-common-flyout__container__textContent .ba-common-paragraph{word-wrap:break-word;margin-top:4px;line-height:1.5;font-weight:regular;color:#525252;font-size:14px}[dir=\"ltr\"].ba-common-flyout__container__textContent .ba-common-paragraph{text-align:left}[dir=\"rtl\"].ba-common-flyout__container__textContent .ba-common-paragraph{text-align:right}[dir=\"ltr\"] .ba-common-flyout__container__textContent .ba-common-paragraph,.ba-common-flyout__container__textContent .ba-common-paragraph{text-align:left}[dir=\"rtl\"] .ba-common-flyout__container__textContent .ba-common-paragraph{text-align:right}.ba-common-flyout__container__textContent.without-link .ba-common-paragraph{margin-bottom:0px;word-wrap:break-word}[dir=\"ltr\"].ba-common-flyout__container__link{text-align:left}[dir=\"rtl\"].ba-common-flyout__container__link{text-align:right}[dir=\"ltr\"] .ba-common-flyout__container__link,.ba-common-flyout__container__link{text-align:left}[dir=\"rtl\"] .ba-common-flyout__container__link{text-align:right}.ba-common-flyout__container__link .ba-common-link{font-size:small;margin:0}.ba-common-flyout__container,.ba-common-flyout__container{z-index:9001}.ba-common-flyout-arrow.is-right{top:11px;left:-11px;border-right-color:rgba(0,0,0,0.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-right{border-right-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-right:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-right:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightBottom{top:11px;left:-11px;border-right-color:rgba(0,0,0,0.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightBottom{border-right-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-rightBottom:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightBottom:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightCentred{bottom:calc(50% - 10px);left:-11px;border-right-color:rgba(0,0,0,0.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightCentred{border-right-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-rightCentred:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightCentred:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-rightTop{bottom:11px;left:-11px;border-right-color:rgba(0,0,0,0.1);border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightTop{border-right-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-rightTop:before{border-right-color:#fff;border-left-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-rightTop:before{border-right-color:#fff}}.ba-common-flyout-arrow.is-left{top:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-left{border-left-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-left:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-left:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftBottom{top:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftBottom{border-left-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-leftBottom:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftBottom:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftTop{bottom:11px;right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftTop{border-left-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-leftTop:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftTop:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-leftCentred{bottom:calc(50% - 10px);right:-11px;border-right-width:0;border-left-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftCentred{border-left-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-leftCentred:before{left:-11px;border-left-color:#fff;border-right-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-leftCentred:before{border-left-color:#fff}}.ba-common-flyout-arrow.is-top,.ba-common-flyout-arrow.is-topLeft,.ba-common-flyout-arrow.is-topRightStart{bottom:-11px;right:11px;border-top-color:rgba(0,0,0,0.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-top,.ba-common-flyout-arrow.is-topLeft,.ba-common-flyout-arrow.is-topRightStart{border-top-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-top:before,.ba-common-flyout-arrow.is-topLeft:before,.ba-common-flyout-arrow.is-topRightStart:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-top:before,.ba-common-flyout-arrow.is-topLeft:before,.ba-common-flyout-arrow.is-topRightStart:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-topCentred{bottom:-11px;left:calc(50% - 10px);border-top-color:rgba(0,0,0,0.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topCentred{border-top-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-topCentred:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topCentred:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-topRight,.ba-common-flyout-arrow.is-topLeftStart{bottom:-11px;left:11px;border-top-color:rgba(0,0,0,0.1);border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topRight,.ba-common-flyout-arrow.is-topLeftStart{border-top-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-topRight:before,.ba-common-flyout-arrow.is-topLeftStart:before{bottom:1px;margin-left:-11px;border-top-color:#fff;border-bottom-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-topRight:before,.ba-common-flyout-arrow.is-topLeftStart:before{border-top-color:#fff}}.ba-common-flyout-arrow.is-bottom,.ba-common-flyout-arrow.is-bottomLeft,.ba-common-flyout-arrow.is-bottomRightStart{top:-11px;right:11px;border-top-width:0;border-bottom-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottom,.ba-common-flyout-arrow.is-bottomLeft,.ba-common-flyout-arrow.is-bottomRightStart{border-bottom-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-bottom:before,.ba-common-flyout-arrow.is-bottomLeft:before,.ba-common-flyout-arrow.is-bottomRightStart:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottom:before,.ba-common-flyout-arrow.is-bottomLeft:before,.ba-common-flyout-arrow.is-bottomRightStart:before{border-bottom-color:#fff}}.ba-common-flyout-arrow.is-bottomRight,.ba-common-flyout-arrow.is-bottomLeftStart{top:-11px;left:11px;border-top-width:0;border-bottom-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomRight,.ba-common-flyout-arrow.is-bottomLeftStart{border-bottom-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-bottomRight:before,.ba-common-flyout-arrow.is-bottomLeftStart:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomRight:before,.ba-common-flyout-arrow.is-bottomLeftStart:before{border-bottom-color:#fff}}.ba-common-flyout-arrow.is-bottomCentred{top:-11px;left:calc(50% - 10px);border-top-width:0;border-bottom-color:rgba(0,0,0,0.1)}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomCentred{border-bottom-color:rgba(255,255,255,0.1)}}.ba-common-flyout-arrow.is-bottomCentred:before{top:1px;margin-left:-11px;border-bottom-color:#fff;border-top-width:0}@media screen and (-ms-high-contrast: active){.ba-common-flyout-arrow.is-bottomCentred:before{border-bottom-color:#fff}}\n", ""]);

// exports
exports.locals = {
	"flyoutClassName": "\"ba-common-flyout\""
};

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getValidPlacement = getValidPlacement;
exports["default"] = getSpecs;

var _utils = __webpack_require__(4);

var _flyoutPosition = __webpack_require__(63);

/* eslint-disable no-param-reassign */

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: @ba/ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var getNearestPositionedParent = _utils.domUtils.getNearestPositionedParent; // Commonly used variables

var invalidSpecs = {
  top: 0,
  left: 0,
  placement: _flyoutPosition.RIGHT,
  invalid: true
};
var shiftArrowInPixel = 23; // Determines base top/left value to use, based off of four situations: Rendered normally (without portal) where trigger has position static,
// rendered normally where trigger has position other than static, added to domNode with position static, or added to domNode with position other than static

function getStartingOffset(positionedAncestorLocation, triggerNode, triggerRectOffset, nearestRectOffset, scrollTopOffset, domNodeToAttachTo, domNodeToAttachToRectOffset) {
  if (domNodeToAttachToRectOffset && window.getComputedStyle(domNodeToAttachTo).getPropertyValue('position') === 'static') {
    return positionedAncestorLocation ? triggerRectOffset - positionedAncestorLocation : triggerRectOffset + scrollTopOffset;
  } else if (typeof domNodeToAttachToRectOffset !== 'undefined') {
    return triggerRectOffset - domNodeToAttachToRectOffset - domNodeToAttachTo.clientTop;
  } else if (window.getComputedStyle(triggerNode).getPropertyValue('position') === 'static') {
    return triggerRectOffset - nearestRectOffset;
  }

  return 0;
}

function validateSpace(orientation, startingSpace, containerRect, triggerRect, options) {
  switch (orientation) {
    case _flyoutPosition.TOP:
      startingSpace -= containerRect.height;
      if (options.arrow) startingSpace -= options.arrow.getBoundingClientRect().height;
      if (typeof options.offset !== 'undefined') startingSpace -= options.offset;
      return startingSpace;

    case _flyoutPosition.BOTTOM:
      startingSpace += triggerRect.height;
      startingSpace += containerRect.height;
      if (options.arrow) startingSpace += options.arrow.getBoundingClientRect().height;
      if (typeof options.offset !== 'undefined') startingSpace += options.offset;
      return startingSpace;

    case _flyoutPosition.LEFT:
      startingSpace -= containerRect.width;
      if (options.arrow) startingSpace -= options.arrow.getBoundingClientRect().width;
      if (typeof options.offset !== 'undefined') startingSpace -= options.offset;
      return startingSpace;

    case _flyoutPosition.RIGHT:
      startingSpace += triggerRect.width;
      startingSpace += containerRect.width;
      if (options.arrow) startingSpace += options.arrow.getBoundingClientRect().width;
      if (typeof options.offset !== 'undefined') startingSpace += options.offset;
      return startingSpace;

    default:
      return startingSpace;
  }
}

function getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options) {
  var containerRect = flyoutContainer.getBoundingClientRect();
  var triggerRect = flyoutTrigger.getBoundingClientRect();
  var shiftArrow = options.arrow ? shiftArrowInPixel : 0;
  var arrowRect;
  if (options.arrow) arrowRect = options.arrow.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop; // default initialization is for window

  var startingTop = triggerRect.top;
  var startingLeft = triggerRect.left;
  var heightToCheck = window.innerHeight;
  var widthToCheck = window.innerWidth;

  if (options.body === 'page') {
    var _document = document,
        body = _document.body;
    var html = document.documentElement;
    var pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.offsetHeight);
    var pageWidth = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.offsetWidth);
    startingTop = triggerRect.top + scrollTop;
    startingLeft = triggerRect.left + scrollLeft;
    heightToCheck = pageHeight;
    widthToCheck = pageWidth;
  }

  var result = {
    top: 0,
    left: 0,
    placement: placement,
    invalid: true
  };
  var resultTop;
  var resultLeft;
  var domNodeToAttachToRect;
  var positionedAncestor = {
    top: 0,
    left: 0
  };

  if (options.domNodeToAttachTo) {
    domNodeToAttachToRect = options.domNodeToAttachTo.getBoundingClientRect();

    if (options.domNodeToAttachTo.offsetParent) {
      positionedAncestor = options.domNodeToAttachTo.offsetParent.getBoundingClientRect();
    }
  }

  var nearestPositionedElement = getNearestPositionedParent(flyoutTrigger);
  var nearestRect = nearestPositionedElement.getBoundingClientRect(); // above is for result initialization

  var placementToValidate = candidatePlacement.slice();
  var index;

  while (result.invalid && placementToValidate.length >= 0) {
    var checkTop = startingTop;
    var checkLeft = startingLeft;
    var extraH = (containerRect.width - triggerRect.width) / 2;
    var extraV = (containerRect.height - triggerRect.height) / 2;

    switch (placement) {
      case _flyoutPosition.TOP:
      case _flyoutPosition.TOP_LEFT:
      case _flyoutPosition.TOP_RIGHT_START:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);
        checkLeft += triggerRect.width - containerRect.width;
        placement !== _flyoutPosition.TOP_RIGHT_START && (checkLeft -= triggerRect.width);
        checkLeft += shiftArrow;

        if (checkTop > 0 && checkLeft > 0 || options["final"] === true) {
          // Do the calculation here
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultLeft -= containerRect.width;
          placement !== _flyoutPosition.TOP_RIGHT_START && (resultLeft -= triggerRect.width);
          resultLeft += shiftArrow;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          // remove placement that is already validated
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1); // get another placement to check

          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.TOP_RIGHT:
      case _flyoutPosition.TOP_LEFT_START:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);
        checkLeft += containerRect.width;
        placement !== _flyoutPosition.TOP_LEFT_START && (checkLeft += triggerRect.width);
        checkLeft -= shiftArrow;

        if (checkTop > 0 && checkLeft < widthToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left);
          placement !== _flyoutPosition.TOP_LEFT_START && (resultLeft += triggerRect.width);
          resultLeft -= shiftArrow;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.TOP_CENTRED:
        checkTop = validateSpace(_flyoutPosition.TOP, startingTop, containerRect, triggerRect, options);

        if (checkTop > 0 && checkLeft - extraH > 0 && checkLeft + triggerRect.width + extraH < widthToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width / 2;
          resultLeft -= containerRect.width / 2;
          if (arrowRect) resultTop -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.BOTTOM:
      case _flyoutPosition.BOTTOM_LEFT:
      case _flyoutPosition.BOTTOM_RIGHT_START:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);
        checkLeft += triggerRect.width - containerRect.width;
        placement !== _flyoutPosition.BOTTOM_RIGHT_START && (checkLeft -= triggerRect.width);
        checkLeft += shiftArrow;

        if (heightToCheck > checkTop && checkLeft > 0 || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultLeft -= containerRect.width;
          placement !== _flyoutPosition.BOTTOM_RIGHT_START && (resultLeft -= triggerRect.width);
          resultLeft += shiftArrow;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.BOTTOM_RIGHT:
      case _flyoutPosition.BOTTOM_LEFT_START:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);
        checkLeft += containerRect.width;
        placement !== _flyoutPosition.BOTTOM_LEFT_START && (checkLeft += triggerRect.width);
        checkLeft -= shiftArrow;

        if (heightToCheck > checkTop && checkLeft < widthToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left);
          placement !== _flyoutPosition.BOTTOM_LEFT_START && (resultLeft += triggerRect.width);
          resultLeft -= shiftArrow;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.BOTTOM_CENTRED:
        checkTop = validateSpace(_flyoutPosition.BOTTOM, startingTop, containerRect, triggerRect, options);

        if (heightToCheck > checkTop && checkLeft - extraH > 0 && checkLeft + triggerRect.width + extraH < widthToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) + triggerRect.height;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width / 2;
          resultLeft -= containerRect.width / 2;
          if (arrowRect) resultTop += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultTop += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.LEFT:
      case _flyoutPosition.LEFT_BOTTOM:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);
        checkTop += triggerRect.height;
        checkTop -= shiftArrow;
        checkTop += containerRect.height;

        if (checkLeft > 0 && heightToCheck > checkTop || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top);
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          resultTop += triggerRect.height;
          resultTop -= shiftArrow;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.LEFT_TOP:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);
        checkTop -= containerRect.height - triggerRect.height;
        checkTop -= triggerRect.height;
        checkTop += shiftArrow;

        if (checkLeft > 0 && checkTop > 0 || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultTop += shiftArrow;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.LEFT_CENTRED:
        checkLeft = validateSpace(_flyoutPosition.LEFT, startingLeft, containerRect, triggerRect, options);

        if (checkLeft > 0 && checkTop - extraV > 0 && checkTop + triggerRect.height + extraV < heightToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height / 2;
          resultTop += triggerRect.height / 2;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) - containerRect.width;
          if (arrowRect) resultLeft -= Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft -= options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.RIGHT:
      case _flyoutPosition.RIGHT_BOTTOM:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);
        checkTop += triggerRect.height;
        checkTop -= shiftArrow;
        checkTop += containerRect.height;

        if (widthToCheck > checkLeft && heightToCheck > checkTop || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top);
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          resultTop += triggerRect.height;
          resultTop -= shiftArrow;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.RIGHT_TOP:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);
        checkTop -= containerRect.height - triggerRect.height;
        checkTop -= triggerRect.height;
        checkTop += shiftArrow;

        if (widthToCheck > checkLeft && checkTop > 0 || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height;
          resultTop += shiftArrow;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      case _flyoutPosition.RIGHT_CENTRED:
        checkLeft = validateSpace(_flyoutPosition.RIGHT, startingLeft, containerRect, triggerRect, options);

        if (widthToCheck > checkLeft && checkTop - extraV > 0 && checkTop + triggerRect.height + extraV < heightToCheck || options["final"] === true) {
          resultTop = getStartingOffset(positionedAncestor.top, flyoutTrigger, triggerRect.top, nearestRect.top, scrollTop, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.top) - containerRect.height / 2;
          resultTop += triggerRect.height / 2;
          resultLeft = getStartingOffset(positionedAncestor.left, flyoutTrigger, triggerRect.left, nearestRect.left, scrollLeft, options.domNodeToAttachTo, domNodeToAttachToRect && domNodeToAttachToRect.left) + triggerRect.width;
          if (arrowRect) resultLeft += Math.min(arrowRect.height, arrowRect.width);
          if (typeof options.offset !== 'undefined') resultLeft += options.offset;
          result = {
            top: Math.round(resultTop),
            left: Math.round(resultLeft),
            placement: placement,
            invalid: false
          };
        } else {
          index = placementToValidate.indexOf(placement);
          placementToValidate.splice(index, 1);
          placement = placementToValidate[0];
        }

        break;

      default:
        return {
          top: 0,
          left: 0,
          placement: placement,
          invalid: true
        };
    }
  }

  return result;
} // Determines the position for flyout, while finding a valid placement and checking if there is space to place the flyout


function getSpecs(flyoutTrigger, flyoutContainer, placement, options, candidatePlacement) {
  if (flyoutTrigger.getBoundingClientRect === undefined || flyoutContainer.getBoundingClientRect === undefined) {
    return invalidSpecs;
  } // Check if a valid placement that fits in the current window the page exists


  options.body = 'window';
  var validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options); // If no valid placement fits in the current window, check if there exists a valid placement on the page (i.e. will not be fully visible in the window, but will fit on the page)

  if (validPlacement.invalid) {
    options.body = 'page';
    validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options);
  } // if no valid placement anyway, display the flyout directly


  if (validPlacement.invalid) {
    options["final"] = true;
    validPlacement = getValidPlacement(flyoutTrigger, flyoutContainer, placement, candidatePlacement, options);
  }

  return validPlacement;
}

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _context = __webpack_require__(24);

var _utils = __webpack_require__(4);

var _Flyout = _interopRequireDefault(__webpack_require__(98));

var _dec, _class, _class2, _temp;

var omit = _utils.lodash.omit;
var ContextFlyout = (_dec = (0, _context.withContext)('theme'), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ContextFlyout, _Component);

  function ContextFlyout() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ContextFlyout.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        theme = _this$props.theme,
        children = _this$props.children;
    var otherProps = omit(this.props, 'theme', 'children', 'className');
    return /*#__PURE__*/_react["default"].createElement(_Flyout["default"], (0, _extends2["default"])({}, otherProps, {
      className: theme + " " + this.props.className,
      ref: function ref(node) {
        _this._flyout = node;
      }
    }), children);
  };

  return ContextFlyout;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", (0, _extends2["default"])({
  theme: _propTypes["default"].string
}, _Flyout["default"].propTypes)), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  className: ''
}), _temp)) || _class);
exports["default"] = ContextFlyout;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__62__;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.POSITIONS = exports.RIGHT_BOTTOM = exports.RIGHT_CENTRED = exports.RIGHT_TOP = exports.RIGHT = exports.LEFT_BOTTOM = exports.LEFT_CENTRED = exports.LEFT_TOP = exports.LEFT = exports.BOTTOM_RIGHT = exports.BOTTOM_LEFT_START = exports.BOTTOM_CENTRED = exports.BOTTOM_RIGHT_START = exports.BOTTOM_LEFT = exports.BOTTOM = exports.TOP_RIGHT = exports.TOP_LEFT_START = exports.TOP_CENTRED = exports.TOP_RIGHT_START = exports.TOP_LEFT = exports.TOP = void 0;

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var TOP = 'top';
exports.TOP = TOP;
var TOP_LEFT = 'topLeft';
exports.TOP_LEFT = TOP_LEFT;
var TOP_RIGHT_START = 'topRightStart';
exports.TOP_RIGHT_START = TOP_RIGHT_START;
var TOP_CENTRED = 'topCentred';
exports.TOP_CENTRED = TOP_CENTRED;
var TOP_LEFT_START = 'topLeftStart';
exports.TOP_LEFT_START = TOP_LEFT_START;
var TOP_RIGHT = 'topRight';
exports.TOP_RIGHT = TOP_RIGHT;
var BOTTOM = 'bottom';
exports.BOTTOM = BOTTOM;
var BOTTOM_LEFT = 'bottomLeft';
exports.BOTTOM_LEFT = BOTTOM_LEFT;
var BOTTOM_RIGHT_START = 'bottomRightStart';
exports.BOTTOM_RIGHT_START = BOTTOM_RIGHT_START;
var BOTTOM_CENTRED = 'bottomCentred';
exports.BOTTOM_CENTRED = BOTTOM_CENTRED;
var BOTTOM_LEFT_START = 'bottomLeftStart';
exports.BOTTOM_LEFT_START = BOTTOM_LEFT_START;
var BOTTOM_RIGHT = 'bottomRight';
exports.BOTTOM_RIGHT = BOTTOM_RIGHT;
var LEFT = 'left';
exports.LEFT = LEFT;
var LEFT_TOP = 'leftTop';
exports.LEFT_TOP = LEFT_TOP;
var LEFT_CENTRED = 'leftCentred';
exports.LEFT_CENTRED = LEFT_CENTRED;
var LEFT_BOTTOM = 'leftBottom';
exports.LEFT_BOTTOM = LEFT_BOTTOM;
var RIGHT = 'right';
exports.RIGHT = RIGHT;
var RIGHT_TOP = 'rightTop';
exports.RIGHT_TOP = RIGHT_TOP;
var RIGHT_CENTRED = 'rightCentred';
exports.RIGHT_CENTRED = RIGHT_CENTRED;
var RIGHT_BOTTOM = 'rightBottom';
exports.RIGHT_BOTTOM = RIGHT_BOTTOM;
var POSITIONS = [TOP, TOP_LEFT, TOP_RIGHT_START, TOP_CENTRED, TOP_LEFT_START, TOP_RIGHT, BOTTOM, BOTTOM_LEFT, BOTTOM_RIGHT_START, BOTTOM_CENTRED, BOTTOM_LEFT_START, BOTTOM_RIGHT, LEFT, LEFT_TOP, LEFT_CENTRED, LEFT_BOTTOM, RIGHT, RIGHT_TOP, RIGHT_CENTRED, RIGHT_BOTTOM];
exports.POSITIONS = POSITIONS;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = _interopRequireDefault(__webpack_require__(14));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _paragraph = _interopRequireDefault(__webpack_require__(62));

var _link2 = _interopRequireDefault(__webpack_require__(29));

var _Flyout = _interopRequireDefault(__webpack_require__(268));

var _FlyoutHelperFunctions = _interopRequireDefault(__webpack_require__(270));

var _flyoutPosition = __webpack_require__(63);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var enableFocusLoop = _utils.domUtils.enableFocusLoop,
    disableFocusLoop = _utils.domUtils.disableFocusLoop;

var flyoutClassName = _Flyout["default"].flyoutClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

function triggerNodePropValidator(props, propName, componentName) {
  if (props.triggerNode !== undefined && props.domNodeToAttachTo === undefined) {
    return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. If a 'triggerNode' argument is passed, a 'domNodeToAttachTo' argument must also be passed.");
  }

  return null;
}

var Flyout = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Flyout, _Component);

  function Flyout(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setFlyoutRef", function (flyout) {
      var startingFocusIndex = _this.props.startingFocusIndex;
      _this._flyout = flyout;

      if (_this._flyout) {
        enableFocusLoop(_this._flyout, startingFocusIndex);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClose", function (event) {
      if (_this._flyout && document.contains(event.target) && !_this._flyout.contains(event.target) && _this._triggerNode.contains && (_this.props.fixedPosition || !_this._triggerNode.contains(event.target))) {
        _this.props.onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      if (e.keyCode === 27) {
        e.stopPropagation();

        _this.props.onClose();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onResize", function () {
      // Only handle the case when window width has actually changed because iPad would send unexpected
      // resize event whenever there is a scrolling occures;
      if (_this.isIPad && _this.windowWidth === window.innerWidth) {
        return;
      }

      _this.windowWidth = window.innerWidth;

      _this._updateLocation();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_updateLocation", function () {
      if (_this._flyout) {
        var options = {
          arrow: _this._arrow,
          offset: _this.props.offset,
          domNodeToAttachTo: _this.props.domNodeToAttachTo
        };
        var specs = (0, _FlyoutHelperFunctions["default"])(_this._triggerNode, _this._flyout, _this.props.placement, options, _this.props.candidatePlacement);

        _this.setState(function () {
          return {
            top: specs.top,
            left: specs.left,
            width: _this._flyoutBox.width,
            height: _this._flyoutBox.height,
            placement: specs.placement,
            hidden: specs.invalid,
            isMounted: true
          };
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isFixedPosititonDefined", function () {
      return _this.props.fixedPosition != null;
    });
    _this.state = {
      placement: props.placement,
      hidden: false,
      isMounted: false
    };
    _this._triggerNode = props.triggerNode;
    _this.windowWidth = window.innerWidth;
    _this.isIPad = navigator.userAgent.match(/iPad/i) !== null;
    return _this;
  }

  var _proto = Flyout.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var onClose = this.props.onClose;
    this._flyoutBox = this._flyout.getBoundingClientRect();
    if (!this._triggerNode) this._triggerNode = this._flyout.parentNode;

    if (this._isFixedPosititonDefined()) {
      this._updateFixedPosition();
    } else {
      this._updateLocation();
    }

    window.addEventListener('resize', this._onResize);

    if (onClose) {
      document.addEventListener('mousedown', this._onClose);
      document.addEventListener('touchstart', this._onClose);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this$state = this.state,
        placement = _this$state.placement,
        isMounted = _this$state.isMounted,
        left = _this$state.left,
        top = _this$state.top;
    this._flyoutBox = this._flyout.getBoundingClientRect();

    if (!this._isFixedPosititonDefined() && (prevState.placement !== placement || prevState.isMounted !== isMounted || prevState.top !== top || prevState.left !== left || prevState.width !== this._flyoutBox.width || prevState.height !== this._flyoutBox.height)) {
      this._updateLocation();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this._onResize);

    if (this.props.onClose) {
      document.removeEventListener('mousedown', this._onClose);
      document.removeEventListener('touchstart', this._onClose);
    }

    disableFocusLoop(this._flyout);
  }
  /**
   * A ref callback called when flyout is mounted or unmounted.
   * @param {Element} flyout The flyout element being mounted/mounted.
   */
  ;

  _proto._updateFixedPosition = function _updateFixedPosition() {
    var position = this.props.fixedPosition;

    var containerRect = this._flyout.getBoundingClientRect();

    var width = containerRect.width + 3;
    var height = containerRect.height + 3;
    var left;

    if (window.innerWidth - position.x < width) {
      left = window.innerWidth - width;
    } else {
      left = position.x;
    }

    var top;

    if (window.innerHeight - position.y < height) {
      top = window.innerHeight - height;
    } else {
      top = position.y;
    }

    this.setState({
      top: top,
      left: left
    });
  };

  _proto._title = function _title(title) {
    if (typeof title === 'string') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-tid": "ba-common-flyout__title",
        className: flyoutClassName + "__container__title"
      }, /*#__PURE__*/_react["default"].createElement(_paragraph["default"], {
        fontWeight: "bold"
      }, " ", title, " "));
    }

    return title;
  };

  _proto._textContent = function _textContent(text) {
    var _this$props = this.props,
        href = _this$props.href,
        link = _this$props.link;
    var noLinkClass = href || link ? '' : ' without-link';

    if (typeof text === 'string') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-tid": "ba-common-flyout__text",
        className: flyoutClassName + "__container__textContent" + noLinkClass
      }, /*#__PURE__*/_react["default"].createElement(_paragraph["default"], null, " ", text, " "));
    }

    return text;
  };

  _proto._link = function _link(href, linkName, link) {
    if (!link && href && linkName) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-tid": "ba-common-flyout__link",
        className: flyoutClassName + "__container__link"
      }, /*#__PURE__*/_react["default"].createElement(_link2["default"], {
        target: "_blank",
        href: href,
        tabIndex: "0"
      }, linkName));
    }

    return link;
  };

  _proto.render = function render() {
    var _cx,
        _cx2,
        _this2 = this;

    var _this$props2 = this.props,
        padding = _this$props2.padding,
        hideArrow = _this$props2.hideArrow,
        children = _this$props2.children,
        domNodeToAttachTo = _this$props2.domNodeToAttachTo,
        className = _this$props2.className,
        title = _this$props2.title,
        textContent = _this$props2.textContent,
        link = _this$props2.link,
        href = _this$props2.href,
        linkName = _this$props2.linkName,
        style = _this$props2.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["padding", "hideArrow", "children", "domNodeToAttachTo", "className", "title", "textContent", "link", "href", "linkName", "style"]);
    var _this$state2 = this.state,
        top = _this$state2.top,
        left = _this$state2.left,
        placement = _this$state2.placement,
        hidden = _this$state2.hidden,
        isMounted = _this$state2.isMounted;
    var classNames = "" + (0, _utils.classnames)(flyoutClassName + "__container", (_cx = {}, _cx["" + placement] = placement, _cx["padding-" + padding] = padding, _cx.hidden = hidden, _cx)) + (linkName || link ? ' has-link' : ' no-link');
    var arrowProps = {
      className: (0, _utils.classnames)('ba-common-flyout-arrow', (_cx2 = {}, _cx2["" + placement] = placement, _cx2)),
      ref: function ref(node) {
        _this2._arrow = node;
      }
    };
    var positions = {
      position: this._isFixedPosititonDefined() || !isMounted ? 'fixed' : 'absolute',
      top: top,
      left: left
    };
    var flyoutProps = (0, _extends2["default"])({}, sanitize(others, Flyout), {
      className: classNames + " " + className,
      style: (0, _extends2["default"])({}, positions, style),
      onKeyDown: this._onKeyDown,
      tabIndex: '0',
      ref: this.setFlyoutRef
    });

    var flyout = /*#__PURE__*/_react["default"].createElement("div", flyoutProps, title && this._title(title), textContent && this._textContent(textContent), (href || link) && this._link(href, linkName, link), children, !hideArrow && /*#__PURE__*/_react["default"].createElement("div", arrowProps));

    return domNodeToAttachTo && isMounted ? _reactDom["default"].createPortal(flyout, domNodeToAttachTo) : flyout;
  };

  return Flyout;
}(_react.Component);

exports["default"] = Flyout;
(0, _defineProperty2["default"])(Flyout, "propTypes", {
  placement: _propTypes["default"].string,
  candidatePlacement: _propTypes["default"].array,
  hideArrow: _propTypes["default"].bool,
  padding: _propTypes["default"].string,
  children: _propTypes["default"].node,

  /** customPropTypes: Element */
  triggerNode: _propTypes["default"].instanceOf(Element) && triggerNodePropValidator,
  domNodeToAttachTo: _propTypes["default"].instanceOf(Element),
  className: _propTypes["default"].string,
  offset: _propTypes["default"].number,
  onClose: _propTypes["default"].func,
  // also allows to pass a react element
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  textContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  link: _propTypes["default"].element,
  href: _propTypes["default"].string,
  linkName: _propTypes["default"].string,
  style: _propTypes["default"].object,
  startingFocusIndex: _propTypes["default"].number,
  fixedPosition: _propTypes["default"].shape({
    x: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    y: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
  })
});
(0, _defineProperty2["default"])(Flyout, "defaultProps", {
  placement: 'right',
  className: '',
  style: {},
  candidatePlacement: _flyoutPosition.POSITIONS,
  startingFocusIndex: -1
});

/***/ })

},[[266,0]]]);
});